import React from 'react';
import styles from './WidgetBox.module.css';
import Loader from 'components/Loader/Loader';

export type LiveUpdateLabelProps = {
    loading: boolean;
};

function LiveUpdateLabel({ loading }: LiveUpdateLabelProps): JSX.Element {
    return (
        <div className={styles.updateLabelBox}>
            {loading ? <Loader size="xs" /> : <div className={styles.updateLiveCircle} />}
            <span>Updating live</span>
        </div>
    );
}

export default LiveUpdateLabel;
